module.exports = __webpack_public_path__ + "static/media/Niveau_elN12_3_459130.9ad8d437.png";